import type {PropType} from 'vue';
import {defineComponent, getCurrentInstance, onBeforeUnmount, onMounted, nextTick} from 'vue';
import {PopinMode} from './Popin.types';

export default defineComponent({
    name: 'PopinButton',
    props: {
        mode: {
            type: String as PropType<PopinMode>,
            required: true,
        },
    },
    emits: {
        click: (_event: MouseEvent) => true,
        mouseenter: (_event: MouseEvent) => true,
        mouseleave: (_event: MouseEvent) => true,
        'element-init': (_element: HTMLElement) => true,
    },
    setup(props, {emit}) {
        const instance = getCurrentInstance();

        function clickEvent(event: MouseEvent) {
            if (props.mode === PopinMode.Click) {
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
            }

            emit('click', event);
        }
        function mouseEnterEvent(event: MouseEvent) {
            if (props.mode === PopinMode.Hover) emit('mouseenter', event);
        }
        function mouseLeaveEvent(event: MouseEvent) {
            if (props.mode === PopinMode.Hover) emit('mouseleave', event);
        }

        onMounted(async () => {
            await nextTick();

            const elRoot = instance?.proxy?.$el.nextElementSibling as HTMLElement;
            if (elRoot) {
                elRoot.addEventListener('click', clickEvent);
                elRoot.addEventListener('mouseenter', mouseEnterEvent);
                elRoot.addEventListener('mouseleave', mouseLeaveEvent);
                emit('element-init', elRoot);
            }
        });

        onBeforeUnmount(() => {
            const elRoot = instance?.proxy?.$el.nextElementSibling as HTMLElement;
            if (elRoot) {
                elRoot.removeEventListener('click', clickEvent);
                elRoot.removeEventListener('mouseenter', mouseEnterEvent);
                elRoot.removeEventListener('mouseleave', mouseLeaveEvent);
            }
        });
    },
    render() {
        return this.$slots?.default?.();
    },
});
